const PrintDC = (title, columns, data) => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
            <head>
                <title>${title}</title>
                <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                    h2 { text-align: center; }
                    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                    th, td { border: 1px solid black; padding: 8px; text-align: left; }
                    th { background-color: #f2f2f2; }
                </style>
            </head>
            <body>
                <h2>${title}</h2>
                <table>
                    <thead>
                        <tr>
                            ${columns.map((col) => `<th>${col}</th>`).join("")}
                        </tr>
                    </thead>
                    <tbody>
                        ${data.map(row => `
                            <tr>${row.map(cell => `<td>${cell}</td>`).join("")}</tr>
                        `).join("")}
                    </tbody>
                </table>
                <script>
                    window.onload = function() { window.print(); window.close(); };
                </script>
            </body>
        </html>
    `);
    printWindow.document.close();
};

export default PrintDC;
